import { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { carFormSchema, CAR_FORM_DEFAULTS } from '../types/car';
import type { CarFormData } from '../types/car';
import { fetchCarData, submitCarForm } from '../api/carApi';

export function useCarForm(carId: string | undefined) {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const form = useForm<CarFormData>({
    resolver: zodResolver(carFormSchema),
    defaultValues: CAR_FORM_DEFAULTS,
    mode: 'onChange',
  });

  // Load existing car data
  useEffect(() => {
    if (!carId) {
      setLoading(false);
      return;
    }

    fetchCarData(carId)
      .then((result) => {
        if (result.success && result.data) {
          form.reset({
            ...CAR_FORM_DEFAULTS,
            ...result.data,
          });
        }
      })
      .catch((error) => {
        console.error('Error loading car data:', error);
      })
      .finally(() => setLoading(false));
  }, [carId, form]);

  const submitForm = useCallback(
    async (data: CarFormData): Promise<{ success: boolean; error?: string }> => {
      if (!carId) {
        return { success: false, error: 'Car ID topilmadi' };
      }

      setSubmitting(true);
      try {
        const result = await submitCarForm(carId, data);
        return result;
      } catch {
        return { success: false, error: "Server bilan bog'lanishda xatolik" };
      } finally {
        setSubmitting(false);
      }
    },
    [carId],
  );

  return { form, loading, submitting, submitForm };
}
